export default "__VITE_ASSET__5VQblwR8__"